import * as React from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogDescription,
} from "@/components/ui/alert-dialog";
import { Activity, Clock } from "lucide-react";

export function InactivityWarning() {
	const { user, session, showInactivityWarning, warningCountdown } = useAuth();

	// Don't render if user is not authenticated or warning is not showing
	if (!user || !session || !showInactivityWarning) {
		return null;
	}

	return (
		<AlertDialog open={showInactivityWarning} onOpenChange={() => {}}>
			<AlertDialogContent className="max-w-md">
				<AlertDialogHeader>
					<AlertDialogTitle className="flex items-center justify-center">
						<Activity className="h-5 w-5 mr-2 text-primary" />
						Are you still there?
					</AlertDialogTitle>
					<div className="text-center my-4">
						<div className="flex items-center justify-center mb-2">
							<Clock className="h-4 w-4 mr-2 text-muted-foreground" />
							<span className="text-sm text-muted-foreground">
								Auto logout in:
							</span>
						</div>
						<div className="text-3xl font-mono text-primary font-bold">
							{warningCountdown}s
						</div>
					</div>
					<AlertDialogDescription className="text-center">
						Move your mouse or interact with the page to stay logged in.
					</AlertDialogDescription>
				</AlertDialogHeader>
			</AlertDialogContent>
		</AlertDialog>
	);
}
